/*
 * Header Component
 * ---
 *
 * @param props.class {String} - this parameter takes in css classes and passes them back down to the component
 * @param
 *
 */

import React from "react";
import Nav, { NavProps } from "../Nav/Nav";

interface HeaderProps extends NavProps {
  className: string;
  isLoggedIn: boolean;
  cartItemsAmount: number;
  wishlistItemsAmount: number;
}

const Header = (props: HeaderProps) => (
  <header>
    <a className="hidden absolute" tabIndex={-1} href="#main-content">
      Skip to main content
    </a>
    <a className="hidden absolute" tabIndex={-1} href="#footer">
      Skip to footer
    </a>
    <Nav {...props} />
  </header>
);

export default Header;
